export default __webpack_public_path__ + "static/media/blue-dots.20eabbfb.svg";